"use client";
import React, { useCallback, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import {
  Segment,
  Item,
  Title,
  Icon,
  Grid,
  GridRow,
  GridColumn,
  Image,
} from "semantic-ui-react";
import { ItemData, Paginate } from "../../components";
import Link from "next/link";
import { relative } from "path";

import { customdecodeURIComponent, getOrdinalSuffix } from "../../common/Utils";

const CityrankingList = ({
  itemData,
  prev,
  active,
  id,
  datamsg,
  onScroll,
  loading,
  isMobile,
  handlesummaryClick,
  ...props
}) => {
  let page_size = 10;
  let indexdata = (active - 1) * page_size;
  let finaldata = [];
  let postal_city_arr = [];
  let npi_duplicate_name = [];
  let sort_value = "npisore";

  itemData &&
    itemData.length > 0 &&
    itemData.map((item, index) => {
      if (
        item.postalcity_name !== "" &&
        postal_city_arr.includes(item.postalcity_name) === false
      ) {
        postal_city_arr.push(item.postalcity_name);
        finaldata.push(item);
        npi_duplicate_name.push({
          id: index,
          postal_name: item.postalcity_name,
          npi: item.npi,
          value: item.value,
        });
      }
      npi_duplicate_name.map((item1, index1) => {
        if (
          item1.postal_name !== "" &&
          item.postalcity_name !== "" &&
          item1.postal_name === item.postalcity_name
        ) {
          if (item1.id !== index) {
            item1.npi = item1.npi + "," + item.npi;
            item1.value = item1.value + "," + item.value;
          }
        }
      });
      let personalNpi = "-";
      if (item.cityaverage && item.cityaverage.length > 0) {
        // item.sort_value = Math.round(item.cityaverage[0].npisore);
        item.personalscore = "-";
      } else {
        // item.sort_value = item.npiscore_city;
        item.personalscore = "-";
      }
    });

  // finaldata.sort((a, b) => {
  //   let fa = parseInt(a.sort_value),
  //     fb = parseInt(b.sort_value);

  //   if (fa < fb) {
  //     return 1;
  //   }
  //   if (fa > fb) {
  //     return -1;
  //   }
  //   return 0;
  // });

  const ref = useRef();
  const handleScrollDiv = () => {
    const div = ref.current;
    onScroll(div);
  };

  return (
    <>
      {datamsg !== "" ? (
        <h3>{datamsg}</h3>
      ) : (
        <div className="scroller" ref={ref} onScroll={handleScrollDiv}>
          <Grid>
            {/* {itemData
            .slice(indexdata)
            .slice(0, page_size)
            .map((item, index) => { */}
            {finaldata.map((item, index) => {
              let indexdata = finaldata.findIndex(
                (itemData) => itemData.id === item.id,
              );
              let npiscore = 0;
              let schoolscore = 0;
              let safetyscore = 0;
              let amentiesscore = "-";
              let pricescore = 0;
              let appereciationscore = "-";
              let domscore = "-";
              let thumbanail = "";
              let final_summary = "";
              if (item.reviewSummary && item.reviewSummary !== null) {
                final_summary = item.reviewSummary;
              }

              let keywords = "";
              if (item.keyword && item.keyword != "") {
                keywords = item.keyword;
              }

              npiscore = ((item.npiscore_city / 100) * 5).toFixed(2);
              schoolscore = ((item.schoolscore_city / 10) * 5).toFixed(2);
              safetyscore = ((item.crimescore_city / 10) * 5).toFixed(2);

              if (item.medianpricescore_city > 0) {
                pricescore = "$" + item.medianpricescore_city.toLocaleString();
              } else {
                pricescore = "-";
              }

              if (parseFloat(item.appreciation) !== 0) {
                appereciationscore = item.appreciation.toFixed(2) + " %";
              } else {
                appereciationscore = "-";
              }

              if (item.cityimage && item.cityimage !== null) {
                thumbanail = item.cityimage;
              }

              return (
                <>
                  {isMobile === true ? (
                    <div className="ranking_wrapper">
                      <Grid>
                        <GridRow className="nhranking_item_section">
                          <GridColumn mobile={1} tablet={1} computer={1}>
                            <div className="nh_ranking_rating_mb">
                              {indexdata + 1}
                              <sup className="nh_ranking_suffix_mb">
                                {getOrdinalSuffix(indexdata + 1)}
                              </sup>
                            </div>
                            {/* <strong>#{indexdata + 1}</strong> */}
                          </GridColumn>
                          <GridColumn mobile={7} tablet={4} computer={4}>
                            <a
                              href={`/City/${item.cityfullname}`}
                              target="_blank"
                              className="nhrankking_img_mb"
                              title={item.postalcity_name}
                            >
                              <Image
                                // classname="mini"
                                src={
                                  thumbanail !== ""
                                    ? thumbanail
                                    : "/static/images/defaultcitymap.jpg"
                                }
                                title="City photo"
                                alt="City photo"
                              />
                            </a>
                          </GridColumn>
                          <GridColumn mobile={7} tablet={4} computer={4}>
                            <h3>
                              <a
                                href={`/City/${item.cityfullname}`}
                                target="_blank"
                                title={item.postalcity_name}
                              >
                                {item.postalcity_name}
                              </a>
                            </h3>
                            <p className="NhrankingP">
                              Overall Score : {Number(npiscore).toFixed(1)}
                            </p>
                          </GridColumn>
                        </GridRow>
                        <GridRow className="nhranking_item_desc">
                          <GridColumn
                            mobile={16}
                            tablet={11}
                            computer={14}
                            className="gridmargin"
                          >
                            <Grid className="gridmargin2 ">
                              <Grid.Row>
                                {/* <GridColumn mobile={5} tablet={5} computer={5}>
                        <p className="NhrankingP">
                          Overall Score : {npiscore}
                        </p>
                      </GridColumn> */}
                                <GridColumn mobile={7} tablet={8} computer={7}>
                                  <p className="NhrankingP">
                                    School : {Number(schoolscore).toFixed(1)}
                                  </p>
                                  <p className="NhrankingP">
                                    Safety : {Number(safetyscore).toFixed(1)}
                                  </p>
                                  {/* <p className="NhrankingP">
                                    Amenities : {amentiesscore}
                                  </p> */}
                                </GridColumn>
                                <GridColumn mobile={8} tablet={8} computer={7}>
                                  <p className="NhrankingP">
                                    Price : {pricescore}
                                  </p>
                                  <p className="NhrankingP">
                                    Appreciation : {appereciationscore}
                                  </p>
                                  {/* <p className="NhrankingP">DOM : {domscore}</p> */}
                                </GridColumn>
                                <GridColumn
                                  mobile={16}
                                  tablet={14}
                                  computer={14}
                                >
                                  {keywords && (
                                    <p className="nhrankingkeywords_mb">
                                      <strong>Keywords:</strong>{" "}
                                      {keywords
                                        .split(",")
                                        .map((word) => word.trim())
                                        .join(", ")}
                                    </p>
                                  )}
                                  {final_summary != "" && (
                                    <>
                                      {final_summary.length > 54 ? (
                                        <p className="nhpannel_desc nhdesc">
                                          {customdecodeURIComponent(
                                            final_summary.slice(0, 250),
                                          )}
                                          <span
                                            className="nhrankingsummary"
                                            onClick={(e) =>
                                              handlesummaryClick(
                                                item.cityfullname,
                                              )
                                            }
                                          >
                                            {" "}
                                            ...See more
                                          </span>
                                        </p>
                                      ) : (
                                        <p className="nhpannel_desc nhdesc">
                                          {customdecodeURIComponent(
                                            final_summary,
                                          )}
                                        </p>
                                      )}
                                    </>
                                  )}
                                </GridColumn>
                              </Grid.Row>
                            </Grid>
                          </GridColumn>
                        </GridRow>
                      </Grid>
                    </div>
                  ) : (
                    <div className="ranking_wrapper">
                      <Grid>
                        <GridRow className="nhranking_item">
                          <GridColumn mobile={1} tablet={1} computer={1}>
                            <div className="nh_ranking_rating">
                              {indexdata + 1}
                              <sup className="nh_ranking_suffix">
                                {getOrdinalSuffix(indexdata + 1)}
                              </sup>
                            </div>
                          </GridColumn>
                          <GridColumn mobile={6} tablet={7} computer={7}>
                            <a
                              href={`/City/${item.cityfullname}`}
                              target="_blank"
                              className="nhrankking_img"
                              title={item.postalcity_name}
                            >
                              <Image
                                // classname="mini"
                                src={
                                  thumbanail !== ""
                                    ? thumbanail
                                    : "/static/images/defaultcitymap.jpg"
                                }
                                title="City photo"
                                alt="City photo"
                              />
                            </a>
                          </GridColumn>
                          <GridColumn mobile={9} tablet={8} computer={8}>
                            <Grid>
                              <Grid.Row>
                                <GridColumn
                                  mobile={8}
                                  tablet={16}
                                  computer={16}
                                >
                                  <h3>
                                    <a
                                      href={`/City/${item.cityfullname}`}
                                      target="_blank"
                                      title={item.postalcity_name}
                                    >
                                      {item.postalcity_name}
                                    </a>
                                  </h3>
                                </GridColumn>
                              </Grid.Row>

                              <p className="NhrankingP">
                                Overall Score : {Number(npiscore).toFixed(1)}
                              </p>
                              <Grid.Row>
                                <GridColumn mobile={5} tablet={5} computer={5}>
                                  <p className="NhrankingP">
                                    School : {Number(schoolscore).toFixed(1)}
                                  </p>
                                  <p className="NhrankingP">
                                    Safety : {Number(safetyscore).toFixed(1)}
                                  </p>
                                  {/* <p className="NhrankingP">
                                    Amenities : {amentiesscore}
                                  </p> */}
                                </GridColumn>
                                <GridColumn mobile={8} tablet={8} computer={8}>
                                  <p className="NhrankingP">
                                    Price : {pricescore}
                                  </p>
                                  <p className="NhrankingP">
                                    Appreciation : {appereciationscore}
                                  </p>
                                  {/* <p className="NhrankingP">DOM : {domscore}</p> */}
                                </GridColumn>
                              </Grid.Row>
                            </Grid>
                          </GridColumn>
                        </GridRow>
                        <Grid.Row style={{ paddingTop: "0px" }}>
                          <GridColumn
                            mobile={14}
                            tablet={1}
                            computer={1}
                          ></GridColumn>
                          <GridColumn mobile={16} tablet={14} computer={14}>
                            {keywords && (
                              <p className="nhrankingkeywords_mb">
                                <strong>Keywords:</strong>{" "}
                                {keywords
                                  .split(",")
                                  .map((word) => word.trim())
                                  .join(", ")}
                              </p>
                            )}
                            {final_summary != "" && (
                              <>
                                {final_summary.length > 54 ? (
                                  <p className="nhpannel_desc nhdesc">
                                    {customdecodeURIComponent(
                                      final_summary.slice(0, 300),
                                    )}
                                    <span
                                      className="nhrankingsummary"
                                      onClick={(e) =>
                                        handlesummaryClick(item.cityfullname)
                                      }
                                    >
                                      {" "}
                                      ...See more
                                    </span>
                                  </p>
                                ) : (
                                  <p className="nhpannel_desc nhdesc">
                                    {customdecodeURIComponent(final_summary)}
                                  </p>
                                )}
                              </>
                            )}
                          </GridColumn>
                        </Grid.Row>
                      </Grid>
                    </div>
                  )}
                </>
              );
            })}
          </Grid>
          {loading ? <p>Loading...</p> : ""}
        </div>
      )}
    </>
  );
};

CityrankingList.propTypes = {
  itemData: PropTypes.array.isRequired,
};

export default CityrankingList;
